export default "__VITE_ASSET__cFC$cjuX__"